import script from "./Loading16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading16167.vue?vue&type=script&setup=true&lang=ts"

import "./Loading16167.vue?vue&type=style&index=0&id=5d80ec64&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d80ec64"]])

export default __exports__